import { Component, Input } from '@angular/core';
import { WucPictureModule } from '@inshared/website-ui-components';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { ApiProductIdEnum, ProductIdEnum } from 'outshared-lib';
import { NgIf } from '@angular/common';
import { ImageSizeInterface } from '@inshared/website-ui-components/components/common/picture/image-size.interface';
import { SessionStorage, SessionStorageService } from '@inshared/shared/util-storage';
import { CollectivityService } from '@inshared/shared/util';
import { CollectiviteitData } from '@inshared/shared/core';

@Component({
    standalone: true,
    selector: 'ins-collectivity-sticker',
    templateUrl: 'collectivity-sticker.component.html',
    imports: [
        WucPictureModule,
        LazyLoadImageModule,
        NgIf
    ],
    providers: [
        CollectivityService,
        {provide: SessionStorageService, useClass: SessionStorage},
    ]
})
export class CollectivityStickerComponent {
    @Input() public productId?: ApiProductIdEnum | ProductIdEnum | string;
    @Input() public location: 'collectivitypage' | 'sidebar' | 'header' = 'header';

    static ASSETS_FOLDER: string = '/assets/shared/09_collectiviteiten/shared/';

    public collectivity: CollectiviteitData | null = this.collectiviteitService.storedData;

    public sizes: { [key: string]: ImageSizeInterface } = {
        collectivitypage: {desktop: 160, mobile: 95},
        sidebar: {desktop: 110, mobile: 80},
        header: {desktop: 60, mobile: 40},
    };

    constructor(
        public collectiviteitService: CollectivityService,
    ) {
    }

    public get imageUrl(): string {
        return `${CollectivityStickerComponent.ASSETS_FOLDER}${this.stickerName}`;
    }

    /**
     * Name based on percentage and location
     *   - 5% - sticker-5.svg
     *   - 10% - sticker-10.svg
     *   - 10% or more - sticker-10-or-more.svg
     *   - 12.5% - sticker-12-5.svg
     *   the mini versions
     *   - 5% - sticker-5-mini.svg
     *   - 10% - sticker-10-mini.svg
     *   - 12.5% - sticker-12-5-mini.svg
     **/
    private get stickerName(): string {

        let percentage: number = this.collectivity?.percentage || 0;
        let suffix: string = '';

        switch (this.location) {
            case 'collectivitypage':
                suffix = `${this.collectivity?.isMinimalPercentage ? '-or-more' : ''}`;
                break;
            case 'header':
                percentage = this.getPercentageForProduct();
                suffix = '-mini';
                break;
            case 'sidebar':
                percentage = this.getPercentageForProduct();
                break;
        }

        const percentageAsString: string = `${percentage}`.replace('.', '-');

        return `sticker-${percentageAsString}${suffix}.svg`;

    }

    private getPercentageForProduct(): number {
        return this.collectivity?.percentages?.[this.productId || '']
            || this.collectivity?.percentages?.['default']
            || this.collectivity?.percentage
            || 0;
    }

}
